jQuery(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip({
        placement: 'bottom',
        template: '<div class="tooltip dnToolTip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        container: $('body').first()
    });
});
